angular.module('bmsApp.dashboard').controller('DashboardCtrl', function ($scope,
                                                                         $rootScope,
                                                                         $state,
                                                                         $timeout,
                                                                         LicenseOptionsSvc,
                                                                         ActivitySvc,
                                                                         CustomerSvc,
                                                                         InstanceSvc,
                                                                         SMJobSvc,
                                                                         SMScheduleSvc,
                                                                         PushNotificationSvc,
                                                                         TGProductSvc,
                                                                         FranchiseSvc,
                                                                         notify,
                                                                         ComplaintSvc,
                                                                         $q) {

    // visiting directly from non-descendant controller
    if ($state.is('main.dashboard')) {
        $state.go('main.dashboard.marketing');
    }

    FranchiseSvc.read().then((response) => {
        $scope.franchise = response.data.franchise;
    });

    $scope.trainingOnlyUser = InstanceSvc.instance.isTrainingUser();
    $scope.notification = '';
    $scope.ecomEnabled = InstanceSvc.instance.ecomEnabled();

    // $scope.showFilter = !$state.is('main.dashboard.overview') && !$state.is('main.dashboard.tickets') && !$state.is('main.dashboard.tickets.save') && !$state.is('main.dashboard.ecommerce') &&
    //     !$state.is('main.dashboard.training') && !$state.is('main.dashboard.leagueTable') && !$state.is('main.dashboard.today');
    $scope.showFilter = $state.is('main.dashboard.marketing') || $state.is('main.dashboard.businessPerformance');

    $scope.showPushNotificationBtn = $state.is('main.dashboard.today');
    $scope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams) {
        $scope.showPushNotificationBtn = toState.name == 'main.dashboard.today' ? true : false;
        let stateName = toState.name;
        $scope.showFilter = stateName === 'main.dashboard.marketing' || stateName === 'main.dashboard.businessPerformance';
        console.log(stateName);
    });

    // $scope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams) {
    // });

    // $scope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams) {
    //     $scope.showFilter = toState.name !== 'main.dashboard.overview' && toState.name !== 'main.dashboard.tickets' && toState.name !== 'main.dashboard.tickets.save' && toState.name !== 'main.dashboard.ecommerce' &&
    //         toState.name !== 'main.dashboard.training' && toState.name !== 'main.dashboard.leagueTable' && toState.name !== 'main.dashboard.today';
    // });

    // visiting from descendant controller
    $scope.$on('$stateChangeStart', function (event, toState) {
        if (toState.name === 'main.dashboard') {
            event.preventDefault();
            $state.go('main.dashboard.overview');
        }

        if (toState.name === 'main.dashboard.jobResolutionTasks') {
            setTimeout(function (){
                broadcastComplaintsCount();
            },2000);

        }
    });


    var dateRangeConfig = $scope.config.datePicker.range;
    dateRangeConfig.options.format = $scope.config.format.date.amShortDate;
    dateRangeConfig.options.opens = 'left';
    delete dateRangeConfig.options.ranges.Today;
    delete dateRangeConfig.options.ranges.Yesterday;

    $scope.data = {
        loading: true,
        updating: false,
        dateRange: {
            startDate: moment().subtract(1, 'month'),
            endDate: moment()
        },
        licenses: {},
        dateRangeOptions: dateRangeConfig
    };

    $scope.activities = {
        loading: true,
        load: function () {
            $scope.activities.loading = true;
            ActivitySvc.upcoming()
                .then(function (response) {
                    // group collection by date
                    var collection;
                    if (response.data.activity_collection.length > 0) {
                        collection = {};
                        angular.forEach(response.data.activity_collection, function (value, key) {
                            var startDate = new moment(value.start);
                            var startDateString = startDate.format('YYYY-DD-MM');
                            if (angular.isObject(collection[startDateString]) !== true) {
                                collection[startDateString] = {
                                    date: startDate,
                                    items: []
                                };
                            }
                            collection[startDateString]['items'].push(value);
                        });
                    }
                    else {
                        collection = null;
                    }
                    $scope.activities.collection = collection;
                    $scope.activities.loading = false;
                });
        },
        collection: null
    };

    $scope.anniversaries = {
        loading: true,
        load: function () {
            $scope.anniversaries.loading = true;
            CustomerSvc.upcomingAnniversaries()
                .then(function (response) {
                    $scope.anniversaries = {
                        customers: response.data.customer_collection,
                        birthdays: response.data.employee_birthday_collection,
                        employee_anniversaries: response.data.employee_anniversary_collection
                    };
                    $scope.anniversaries.loading = false;

                });
        },
        collection: []
    };

    $scope.lowStockIndicator = {
        loading: true,
        load: function () {
            $scope.lowStockIndicator.loading = true;
            TGProductSvc.lowStockIndicator()
                .then(function (response) {
                    $scope.lowStockIndicator.collection = response.data.product_collection;
                    $scope.lowStockIndicator.loading = false;
                });
        },
        collection: []
    };

    $scope.todaysTasks = {
        loading: true,
        load: function() {
            var dt = moment().format('YYYY-MM-DD');
            SMScheduleSvc.forDate(dt).then(function(response) {
                $scope.todaysTasks.collection = response.data.visit_collection;
                $scope.todaysTasks.loading = false;
            });
        },
        collection: []
    };

	// $scope.unconfirmedTechnicianJobNotifications = {
	// 	loading: false,
	// 	load: function () {
    //         $scope.unconfirmedTechnicianJobNotifications.collection = [];
	// 		$scope.unconfirmedTechnicianJobNotifications.loading = true;
	// 		SMJobSvc.unconfirmedTechnicianJobNotifications()
	// 			.then(function (response) {
	// 				$scope.unconfirmedTechnicianJobNotifications.collection = response.data.job_collection;
	// 				$scope.unconfirmedTechnicianJobNotifications.loading = false;
	// 			});
	// 	},
	// 	markConfirmed: function (jobId) {
	// 		return SMJobSvc.confirmTechnicianJobNotification(jobId)
	// 			.then(function () {
	// 				$scope.unconfirmedTechnicianJobNotifications.load();
	// 			});
	// 	},
	// 	collection: []
	// };

    $scope.filter = {
        dateRange: {
            startDate: moment().subtract(1, 'month'),
            endDate: moment()
        },

        license: {
            // TODO: Should be first license in system or all licenses
            id: 0
        }
    };

    $scope.actions = {
        showPushNotificationModal: function(){
            PushNotificationSvc.showModal()
                .then(function (modalResult) {
                    notify({
                        message: 'Push notification sent successfully'
                    });
                });
            ;
        },

        applyFilter: function () {
            angular.extend($scope.data, {
                license: $scope.filter.license
            });
            let startDate = $scope.filter.dateRange.startDate;
            if (moment.isMoment(startDate)) {
                startDate = startDate.format('YYYY-MM-DD');
            }
            let endDate = $scope.filter.dateRange.endDate;
            if (moment.isMoment(endDate)) {
                endDate = endDate.format('YYYY-MM-DD');
            }
            angular.extend($scope.data.dateRange, {
                startDate: startDate,
                endDate: endDate,
            });
        },
        barOrLineEmpty: function (data) {
            var empty = true;
            if (angular.isObject(data)) {
                angular.forEach(data, function (value) {
                    if (angular.isObject(value) && angular.isArray(value.data)) {
                        angular.forEach(value.data, function (value) {
                            if (value) {
                                empty = false;
                            }
                        });
                    }
                });
            }
            return empty;
        }
    };

    LicenseOptionsSvc
        .license()
        .then(function (response) {
            $scope.data.licenses = response.data.options;
            $timeout(function () {
                $scope.data.loading = false;

            }, 250);
        });

    LicenseOptionsSvc
        .notification()
        .then(function (response) {
            $scope.notification = response.data.notification.message || '';
        });

    // if ($scope.isMM() || $scope.isTG() || $scope.isSM()) {
    //     $scope.activities.load();
    //     if ($scope.isMM()) {
    //         $scope.anniversaries.load();
    //     }
    //     if ($scope.isTG()) {
    //         $scope.lowStockIndicator.load();
    //     }
    //     if ($scope.isSM()) {
    //         $scope.todaysTasks.load();
    //         $scope.unconfirmedTechnicianJobNotifications.load();
    //     }
    // }

    $scope.loadCount = function(){
        var promises = {
            countsRes: ComplaintSvc.alertCount(),
        };

        $q.all(promises)
            .then(function (responses) {
                $scope.jobResolutionComplaintsOpenCount = responses.countsRes.data.jobResTasksCount;
                $scope.regularComplaintsOpenCount = responses.countsRes.data.regularComplaintsCount;
                $scope.openComplaintsCount = $scope.jobResolutionComplaintsOpenCount + $scope.regularComplaintsOpenCount;
                broadcastComplaintsCount();
            });
    }

    function broadcastComplaintsCount(){
        $rootScope.$broadcast('openComplaintsTotalCountUpdated', {
            jobResolutionComplaintsOpenCount: $scope.jobResolutionComplaintsOpenCount,
            regularComplaintsOpenCount: $scope.regularComplaintsOpenCount,
        });
    }

    $scope.loadCount();

    $rootScope.$on('complaintsLoaded', function (evt) {
        $scope.loadCount();
    });

});
